export class FormAtylRestriction<T> {
    type: string;
    value: string;
    messageError: string;

    constructor(restrictions: {
            type?: string,
            value?: string,
            messageError?: string
        } = {}) {
        this.type = restrictions.type || '';
        this.value = restrictions.value || '';
        this.messageError = restrictions.messageError || '';
    }
}